import React from "react";

import styles from "./spinner.module.scss";

const Spinner = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.loadingioSpinnerSpinner6l6y7wnc6vp}>
        <div className={styles.ldioYc6vm4251k9}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
